import { ICartItem } from '@ApiModels/viewCart';

export const bnplCal = (item: ICartItem) =>
	Number(item?.plan?.BNPL_UPFRONT_MINUS_VAT) +
	Number(item?.plan?.IV) * (Number(item?.plan?.installmentDuration) - 1) +
	Number(item?.plan?.BNPLFEP);
